import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableQuestionInput extends React.Component {
    state = {
    }

    componentDidMount() {
        // console.log('TableQuestionInput', this.props.data)
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let styleInfo = this.props.styleInfo
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data && (
                    // <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{String(this.props.data)}</p>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>{((this.props.data).length)}</p>
                )}
            </div>
        )
    }
}

export default TableQuestionInput;